// eslint-disable-next-line import/prefer-default-export
export const initialState = {
  adminSingleProduct: false,
  adminAssociationsGroup: false,
  addAssociationConfirmation: false,
  deleteAssociationConfirmation: false,
  deleteProductConfirmation: false,
  deleteAllProducts: false,
  deleteAllProductGroups: false,
  deleteAllAssociations: false,
};
